// @flow

import type {
  PropsSchema,
  EasyAction,
  EventSourceMap,
  BasicProps
} from '../../type'
import type { Props as EasyCompProps } from '../EasyCompComponent'

import * as React from 'react'
import { toast } from 'frame/ui/popup'
import {
  initShareInfo,
  showShareAlert,
  hiddenShareButton
} from 'frame/core/share'
import * as allApp from 'frame/core/app/all'
import computeData from '../hoc/computeData'
import rootComp from '../hoc/rootComp'
import { getVisitor } from '../../redux/basic'
import { getPageInfo, getQuery } from '../../pageInfo'
import * as FengjrApp from 'frame/core/app/fengjr'
import * as browserEnv from 'frame/core/browserEnv'
import { history, location } from 'frame/core/window'
import { hideMenu, showMenu } from 'frame/core/wx'
import { postMessage } from 'frame/core/app/weixin'
import * as analysis from 'frame/core/analysis'

type EasyCompElement = React.Element<React.ComponentType<EasyCompProps>>;
type Image = {
  url: string,
  originWidth: number,
  originHeight: number
};
type Props = BasicProps & {
  style: { [string]: string },
  events: EventSourceMap,
  children: React.ChildrenArray<EasyCompElement>,
  shareImg?: Image,
  userName: string,
  miniShareImg?: Image,
  hidenWxMenu: boolean,
  url?: string,
  desc?: string,
  title?: string,
  closeLeftGesture?: boolean,
  hideBackIcon?: boolean,
  IOSPageShow?: boolean,
  openShare?: boolean,
  parseUrl: (url: string, dynamicData: any) => string,
  actionPushPage: (
    data: { h5: string, app?: ?string },
    dynamicData: any
  ) => void
};

type State = {
  shareInfo: ?Object
};

@computeData({ includeVisible: false })
@rootComp
export default class Root extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      title: '服务端调用',
      event: 'initialProps'
    },
    {
      type: 'event',
      title: '就绪',
      event: 'ready'
    },
    {
      type: 'event',
      title: 'app跳回h5调用',
      event: 'appToH5'
    },
    {
      type: 'event',
      title: '活动结束',
      event: 'specialEnd'
    },
    'separator',
    {
      type: 'boolean',
      key: 'isSupportPTR',
      title: '是否支持下拉刷新',
      visible: () => getPageInfo().platform === 'app'
    },
    {
      type: 'boolean',
      key: 'closeLeftGesture',
      title: '关闭app右滑手势'
    },
    'separator',
    {
      type: 'boolean',
      key: 'hideBackIcon',
      title: '隐藏返回按钮(只有喜鹊快贷有这个方法)'
    },
    'separator',
    {
      type: 'boolean',
      key: 'IOSPageShow',
      title: '兼容IOS后退刷新页面'
    },
    'separator',
    {
      type: 'boolean',
      key: '_isON',
      title: '是否开启接口用户状态'
    },
    'separator',
    {
      type: 'boolean',
      key: '_sqIsKeepFlag',
      title: '是否开启社区关注接口（是否已关注大咖）'
    },
    'separator',
    {
      type: 'boolean',
      key: 'openShare',
      title: '就绪开启分享'
    },
      {
      type: 'boolean',
      key: 'isShowRightShareIcon',
      title: '是否隐藏APP右上角分享按钮'
    },
    {
      type: 'text',
      key: 'title',
      title: '标题：'
    },
    {
      type: 'text',
      key: 'desc',
      title: '描述：',
      visible: () => getPageInfo().platform !== 'miniPro'
    },
    {
      type: 'textarea',
      key: 'url',
      title: '链接：'
    },
    {
      type: 'image',
      key: 'shareImg'
    },
    {
      type: 'image',
      key: 'miniShareImg',
      title: '小程序分享图片'
    },
    {
      key: 'userName',
      title: '选择小程序',
      type: 'select',
      options: [
        ['gh_93f657211f55', '保险小程序'],
        ['gh_9d05af55a806', '凤凰金融小程序']
      ],
      defaultValue: 'gh_93f657211f55'
    },
    {
      type: 'event',
      event: 'shareSuccess',
      title: '分享成功'
    },
    {
      type: 'event',
      event: 'shareFail',
      title: '分享失败'
    },
    {
      type: 'boolean',
      key: 'hidenWxMenu',
      title: '隐藏微信菜单按钮'
    },
    'separator',
    {
      type: 'text',
      key: 'documentTitle',
      title: '浏览器页签标题'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '页面跳转',
      name: 'pushPage',
      dataSchema: [
        {
          key: 'h5',
          title: '跳转到 H5 网页'
        },
        {
          key: 'mpUrl',
          title: '小程序地址(小程序环境支持)'
        },
        {
          key: 'openNewWebView',
          title: 'app中打开新Webview',
          type: 'boolean'
        },
        {
          key: 'miniProOpenNewWebView',
          title: '小程序中打开新Webview',
          type: 'boolean'
        },
        {
          key: 'app',
          title: '跳转到 APP 本地页面'
        },
        {
          key: 'thirdPartyAppsUrl',
          title: '打开第三方APP(喜鹊快贷)'
        },
        {
          key: 'forceRefresh',
          title: '刷新h5页面',
          type: 'boolean'
        },
        {
          key: 'replaceHistory',
          title: '是否replace',
          type: 'boolean'
        },
        {
          key: 'closeAppWebviewMode',
          title: '关闭 App 页面模式',
          type: 'select',
          options: ['closeToRoot', 'close']
        }
      ]
    },
    {
      title: '页面返回',
      name: 'goBack'
    },
    {
      title: '弹出分享框',
      name: 'shareAlert'
    },
    {
      title: '开启分享',
      name: 'asyncOpenShare'
    },
    {
      title: '截屏分享到微信',
      name: 'sharePageToWeixin'
    },
    {
      title: '弹出toast',
      name: 'toast',
      dataSchema: [
        {
          key: 'message',
          title: '内容',
          required: true
        }
      ]
    },
    {
      title: '去登录',
      name: 'toLogin',
      dataSchema: [
        {
          key: 'backUrl',
          title: '登录后返回的页面（不填则为当前页面）',
          placeholder: '不填返回到当前页面'
        }
      ]
    },
    {
      title: '百信成功后',
      name: 'baixinSuccessCb'
    },
    {
      title: '百信失败后',
      name: 'baixinErrorCb'
    },
    {
      title: '给小程序发消息',
      name: 'postMsgToWeixinApp'
    },
    {
      title: '复位(仅ios)',
      name: 'iosReset'
    },
    {
      title: '显示返回按钮(喜鹊)',
      name: 'showBackIcon'
    }
  ];
  actionBaixinSuccessCb = (data: any, dynamicData: any) => {
    FengjrApp.baixinSuccess(dynamicData)
  };
  actionBaixinErrorCb = (data: any, dynamicData: any) => {
    FengjrApp.baixinError(dynamicData)
  };
  actionPostMsgToWeixinApp = (data: any, dynamicData: any) => {
    if (browserEnv.isInWeixinApp()) {
      postMessage(dynamicData)
    }
  };
  actionIosReset = () => {
    setTimeout(() => {
      document.body && (document.body.scrollTop += 1)
    }, 1)
  };
  state = {
    shareInfo: null
  };
  actionToLogin = (data: ?{ backUrl?: string }, dynamicData: any) => {
    const { jsEnv } = this.props
    let marketplace = getPageInfo().marketplace
    let { backUrl } = data || {}
    backUrl = backUrl || window.location.href
    let h5 = '/cn/re/account/new/login-mobile?rd='
    if (getPageInfo().marketplace === 'ydd') {
      h5 = `/cn/re/account/new/login-mobile?clientCode=MAGPIE&rd=`
    }
    if (marketplace === 'abroad') {
      h5 = '/gblwx/hw/login?outback='
    }
    h5 += encodeURIComponent(
      jsEnv.getStringWithAdditionCtx(backUrl, dynamicData)
    )
    this.props.actionPushPage(
      {
        h5,
        app: '/appLogin'
      },
      dynamicData
    )
  };

  actionGoBack = () => {
    if (
      browserEnv.isInFjApp() ||
      browserEnv.isInYddApp() ||
      browserEnv.isInLcsApp() ||
      browserEnv.isInXqkdApp()
    ) {
      FengjrApp.goBack()
    } else {
      this.historyBack()
    }
  };
  historyBack = () => {
    if (browserEnv.isInWeixinApp()) {
      allApp.historyBack()
    } else {
      if (/\bbackToHome\b/.test(location.search)) {
        location.href = '/'
      } else {
        history.back()
      }
    }
  };

  actionToast = ({ message }: { message: string }, dynamicData: any) => {
    const { jsEnv } = this.props
    toast(jsEnv.getStringWithAdditionCtx(message, dynamicData))
  };

  actionAsyncOpenShare = (data: any, dynamicData: Object) => {
    const shareInfo = this.getShareObj(dynamicData)
    if (shareInfo) {
      initShareInfo(shareInfo)
    }
  };

  actionSharePageToWeixin = () => {
    allApp.sharePageToWeixin()
  };

  actionShowBackIcon = () => {
    allApp.showBackIcon()
  };
  constructor (props: Props) {
    super(props)
    this.restore()
    this.actionPostMsgToWeixinApp(null, { fun: 'share' })
    window.addEventListener('beforeunload', () => {
      this.restore()
    })
    if (props.documentTitle) {
      document.title = props.documentTitle
    }
  }

  restore () {
    hiddenShareButton()
    if (browserEnv.isInFjApp() || browserEnv.isInXqkdApp()) {
      FengjrApp.restoreGoBack()
      allApp.setNavigationBarRightButton({
        text: '',
        image: '',
        clickCallback: () => {}
      })
    }
  }

  componentDidMount () {
    const {
      callActions,
      openShare,
      events = {},
      closeLeftGesture,
      hideBackIcon,
      hidenWxMenu,
      IOSPageShow,
      isShowRightShareIcon
    } = this.props
    const { appToH5 = {} } = events
    const { targets = [] } = appToH5
    const shareInfo = this.getShareObj()
    if (openShare && shareInfo) {
      initShareInfo(shareInfo,isShowRightShareIcon)
    }
    if (closeLeftGesture && browserEnv.isInApp()) {
      allApp.closeLeftGesture()
    }
    if (IOSPageShow && browserEnv.isInIOSApp()) {
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
          window.location.reload()
        }
      })
    }

    if (hideBackIcon && browserEnv.isInApp()) {
      allApp.hideBackIcon()
    }
    if (browserEnv.isInYddApp()) {
      allApp.initPage()
    }
    if (hidenWxMenu) {
      hideMenu()
    } else {
      showMenu()
    }
    window.appBackToH5=function(){}
    if (targets.length > 0) {
      window.appBackToH5 = function () {
        analysis.trackPageview()
        callActions('appToH5')
      }
    }

    setTimeout(() => {
      callActions('ready')
      callActions('initialProps')
      const { endDate, offsetTime } = getPageInfo()
      const serverTime = +new Date() + offsetTime
      if (+new Date(endDate) < serverTime) {
        callActions('specialEnd')
      }
    }, 100)
  }

  getShareObj = (dynamicData: ?Object) => {
    const { shareImg, callActions, jsEnv, userName, miniShareImg } = this.props
    let { url, title, desc } = this.props
    const { shareInfo } = this.state
    if (shareInfo && !dynamicData) {
      return shareInfo
    }
    if (dynamicData && dynamicData.self) {
      url = '${href}'
      title = '${title}'
      desc = '${desc}'
    }
    if (url && title) {
      dynamicData = dynamicData || {}
      const shareInfo = {
        link: this.getShareUrl(url, dynamicData),
        title: jsEnv.getStringWithAdditionCtx(title, dynamicData),
        imgUrl:
          (dynamicData && dynamicData.url) || (shareImg ? shareImg.url : ''),
        miniShareImgUrl:
          (dynamicData && dynamicData.miniImgUrl) ||
          (miniShareImg && miniShareImg.url),
        desc: desc ? jsEnv.getStringWithAdditionCtx(desc, dynamicData) : '',
        userName,
        success: () => {
          callActions('shareSuccess')
        },
        failure: () => {
          callActions('shareFail')
        }
      }
      this.setState({ shareInfo })
      return shareInfo
    }
    return null
  };

  getShareUrl (url: string, dynamicData: any) {
    const { parseUrl } = this.props
    const inviteCode = getVisitor().inviteCode || getQuery().inviteCode
    let shareUrl = parseUrl(url, dynamicData)
    if (!/^\w+:/.test(shareUrl)) {
      shareUrl = window.location.origin + shareUrl
    }
    if (!inviteCode) {
      return shareUrl
    }
    if (shareUrl.indexOf('?') !== -1) {
      const search = shareUrl.split('?')[1]
      if (search.indexOf('inviteCode') !== -1) {
        return shareUrl
      }
      shareUrl += '&'
    } else {
      shareUrl += '?'
    }
    shareUrl = shareUrl + 'inviteCode=' + inviteCode
    return shareUrl
  }

  actionShareAlert = (data: any, dynamicData: any) => {
    const shareInfo = this.getShareObj(dynamicData)
    if (shareInfo) {
      showShareAlert(shareInfo)
    }
  };

  render () {
    const { id, style, children } = this.props
    return (
      <div
        style={{ position: 'relative', minHeight: '100%', ...style }}
        id={id}
      >
        <div style={style.height ? { height: style.height } : {}}>
          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/RootMobile.js